export const CATEGORIES = [
  "Railway Electrical",
  "Railway Lighting",
  "Traction & Earthing",
  "Electromechanical",
  "Pipe Fittings",
  "Railway Coach Equipment",
];

export const SPEC_NOTE =
  "Detailed technical specifications are supplied on request. All specifications shown here are placeholders and can be updated at any time.";

// Central product catalogue.
// image: null  -> professional IMAGE PLACEHOLDER renders (upload path/URL here later)
// comingSoon   -> premium COMING SOON banner renders instead of a photograph
export const PRODUCTS = [
  {
    id: "earthing-choke",
    name: "EARTHING CHOKE",
    category: "Traction & Earthing",
    description:
      "Earthing choke engineered for railway traction and earthing circuits, built for dependable electrical continuity, robust construction and long service life.",
    application: "Railway traction earthing applications. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: true,
  },
  {
    id: "load-resistor",
    name: "LOAD RESISTOR",
    category: "Railway Electrical",
    description:
      "Load resistor manufactured for railway electrical circuits, with emphasis on thermal stability, build quality and consistent, reliable performance.",
    application: "Railway electrical circuits and control panels. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: true,
  },
  {
    id: "earth-return-brush-with-holder",
    name: "EARTH RETURN BRUSH WITH HOLDER",
    category: "Traction & Earthing",
    description:
      "Earth return brush with holder assembly for rolling stock earthing paths, finished and fitted with a focus on precision, conductivity and durability.",
    application: "Rolling stock earthing systems. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: false,
  },
  {
    id: "steel-plug",
    name: "STEEL PLUG",
    category: "Electromechanical",
    description:
      "Precision-machined steel plug for railway and industrial applications, manufactured to consistent quality standards with careful finish and fit.",
    application: "Railway and industrial fittings. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: false,
  },
  {
    id: "pantograph-disconnecting-earthing-device",
    name: "PANTOGRAPH DISCONNECTING + EARTHING DEVICE",
    category: "Traction & Earthing",
    description:
      "Pantograph disconnecting and earthing device supporting safe isolation and earthing in overhead traction systems, manufactured with quality-focused processes.",
    application: "Overhead traction isolation and earthing. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: true,
  },
  {
    id: "steel-pipe-fittings",
    name: "STEEL PIPE FITTINGS",
    category: "Pipe Fittings",
    description: "Steel pipe fittings for railway and industrial fluid lines. Detailed information will be available soon.",
    application: "Detailed application information will be published soon.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "brass-pipe-fittings",
    name: "BRASS PIPE FITTINGS",
    category: "Pipe Fittings",
    description: "Brass pipe fittings engineered for corrosion resistance and dependable sealing. Detailed information coming soon.",
    application: "Detailed application information will be published soon.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "copper-pipe-fittings",
    name: "COPPER PIPE FITTINGS",
    category: "Pipe Fittings",
    description: "Copper pipe fittings for railway and industrial applications. Detailed information coming soon.",
    application: "Detailed application information will be published soon.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "cab-heater",
    name: "CAB HEATER",
    category: "Railway Coach Equipment",
    description:
      "Cab heater designed for locomotive and coach cab environments, built for reliable performance across demanding duty cycles.",
    application: "Locomotive and coach cab environments. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: true,
  },
  {
    id: "stainless-steel-pipe-fittings",
    name: "STAINLESS-STEEL PIPE FITTINGS",
    category: "Pipe Fittings",
    description:
      "Stainless-steel pipe fittings offering strength and corrosion resistance for demanding railway and industrial lines.",
    application: "Railway and industrial fluid lines. Detailed specifications available on request.",
    image: null,
    status: "placeholder",
    comingSoon: false,
    featured: false,
  },
  {
    id: "flasher-light",
    name: "FLASHER LIGHT",
    category: "Railway Lighting",
    description: "Flasher light for railway indication duties. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "marker-light",
    name: "MARKER LIGHT",
    category: "Railway Lighting",
    description: "Marker light for rolling stock identification and visibility. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "signal-exchange-light",
    name: "SIGNAL EXCHANGE LIGHT",
    category: "Railway Lighting",
    description: "Signal exchange light for railway signal applications. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "roof-mounted-air-conditioner",
    name: "ROOF MOUNTED AIR CONDITIONER",
    category: "Railway Coach Equipment",
    description: "Roof mounted air conditioner for railway coach comfort systems. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "master-controller",
    name: "MASTER CONTROLLER",
    category: "Electromechanical",
    description: "Master controller for locomotive traction control interfaces. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "uic-socket",
    name: "UIC SOCKET",
    category: "Railway Electrical",
    description: "UIC socket for coach electrical interconnections. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "foot-light",
    name: "FOOT LIGHT",
    category: "Railway Lighting",
    description: "Foot light for coach interiors and gangways. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "cab-light",
    name: "CAB LIGHT",
    category: "Railway Lighting",
    description: "Cab light for locomotive and cab workspace illumination. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
  {
    id: "coach-interior-light",
    name: "COACH INTERIOR LIGHT",
    category: "Railway Lighting",
    description: "Coach interior light for passenger compartment illumination. Details to be announced.",
    application: "Details to be announced.",
    image: null,
    status: "coming-soon",
    comingSoon: true,
    featured: false,
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
